import React, { memo } from 'react';

import { Icons, PageTitle } from '@components/common';

import { EAdminPanelPageTitles } from '@enums/common';

import AlarmManagementByVendor from './AlarmManagementByVendor';

import styles from './AlarmManagement.module.scss';

const AlarmManagement = () => {
	return (
		<div className={styles.alarmManagementContainer}>
			<PageTitle
				icon={Icons.alarmInverse()}
				title={EAdminPanelPageTitles.AlarmManagement}
			/>
			<AlarmManagementByVendor />
		</div>
	);
};

export default memo(AlarmManagement);
